var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49956 12.0135L11.2662 13.6868C11.7729 13.9935 12.3929 13.5402 12.2596 12.9668L11.5262 9.82017L13.9729 7.70017C14.4196 7.3135 14.1796 6.58017 13.5929 6.5335L10.3729 6.26017L9.11289 3.28684C8.88623 2.74684 8.11289 2.74684 7.88623 3.28684L6.62623 6.2535L3.40623 6.52684C2.81956 6.5735 2.57956 7.30684 3.02623 7.6935L5.47289 9.8135L4.73956 12.9602C4.60623 13.5335 5.22623 13.9868 5.73289 13.6802L8.49956 12.0135Z",
    fill: "#FFDD67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundStarIcon);
export default __webpack_public_path__ + "static/media/round-star-icon.c7a2115a6740e10ee2fb929e1ff5562f.svg";
export { ForwardRef as ReactComponent };